import { render } from "./VetRecordTableRow.vue?vue&type=template&id=deba2e80&scoped=true&ts=true"
import script from "./VetRecordTableRow.vue?vue&type=script&lang=ts"
export * from "./VetRecordTableRow.vue?vue&type=script&lang=ts"

import "./VetRecordTableRow.vue?vue&type=style&index=0&id=deba2e80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deba2e80"]])

export default __exports__